import React, { useContext, useEffect, useState } from 'react'
import API from '../../../../services/API'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import BigModal from '../../../../components/Modals/BigModal'
import { Autocomplete, Button, InputAdornment, TextField } from '@mui/material'
import { GlobalContext } from '../../../../App'
import SmallModal from '../../../../components/Modals/SmallModal'

const Hospitals = () => {
  const [hospitalOptions, setHospitalOptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const { setToast } = useContext(GlobalContext)
  const [confirmDelete, setConfirmDelete] = useState(false)

  const fetchHospitalList = () => {
    setLoading(true)
    API.get('/eventplanning/hospitals')
      .then((res) => {
        if (res.status === 200) {
          setHospitalOptions(res.data)
        }
      })
      .catch((e) => setFetchError(true))
      .finally(() => setLoading(false))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    API.put(`/eventplanning/hospitals/${selectedItem._id}`, selectedItem)
      .then((res) => {
        if (res.status === 200) {
          setSelectedItem(null)
          fetchHospitalList()
          setToast({ message: 'Destination Updated' })
        }
      })
      .catch(() =>
        setToast({
          message: 'Unable to update destination. Please try again later.',
          severity: 'error',
        }),
      )
  }

  const handleDelete = () => {
    API.delete(`/eventplanning/hospitals/${selectedItem._id}`).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Destination Deleted' })
        setSelectedItem(null)
        setConfirmDelete(false)
        fetchHospitalList()
      }
    })
  }

  useEffect(() => fetchHospitalList(), [])

  return (
    <Stack gap={1}>
      <Typography variant="title2">Hospitals & Destinations</Typography>
      <CustomDataGrid
        rows={hospitalOptions}
        loading={loading}
        columns={[
          { field: 'name', headerName: 'Name', minWidth: 200, flex: 0.8 },
          {
            field: 'type',
            headerName: 'Type',
            valueGetter: (value) => value.join(', '),
            minWidth: 200,
            flex: 1,
          },
        ]}
        getRowId={(params) => params._id}
        disableRowSelectionOnClick
        onRowClick={({ row }) => setSelectedItem(row)}
      />
      <BigModal
        open={!!selectedItem}
        onClose={() => setSelectedItem(null)}
        autoWidth
      >
        <Stack gap={1} component="form" onSubmit={handleSubmit}>
          <Typography variant="title3" textAlign="center">
            Edit Destination
          </Typography>
          <TextField
            label="Destination Name"
            value={selectedItem?.name}
            onChange={(e) =>
              setSelectedItem((prev) => ({ ...prev, name: e.target.value }))
            }
            autoComplete="off"
            name="addhospitalname"
            required
          />
          <Autocomplete
            options={[
              'Emergency Department',
              'PPCI',
              'Stroke',
              'Trauma Unit',
              'Major Trauma Centre',
              'Minor Injury Unit',
              'Paediatrics',
              'Paediatric MTC',
            ]}
            freeSolo
            value={selectedItem?.type}
            multiple
            onChange={(e, newValue) =>
              setSelectedItem((prev) => ({ ...prev, type: newValue }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Type"
                inputProps={{
                  ...params.inputProps,
                  required: selectedItem.type.length === 0,
                }}
              />
            )}
          />
          <TextField
            label="Public Phone Number"
            required
            value={selectedItem?.publicPhone}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                publicPhone: e.target.value,
              }))
            }
            helperText="For public use"
            autoComplete="off"
            name="addhospital-publicphone"
          />
          <TextField
            label="Private Phone Number"
            required
            value={selectedItem?.privatePhone}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                privatePhone: e.target.value,
              }))
            }
            helperText="Not for public use"
            error
            autoComplete="off"
            name="addhospital-privatephone"
          />
          <TextField
            label="Address"
            required
            fullWidth
            onChange={(e) =>
              setSelectedItem((prev) => ({ ...prev, address: e.target.value }))
            }
            value={selectedItem?.address}
            autoComplete="off"
            name="addhospitaladdress"
          />
          <TextField
            label="What3Words"
            value={selectedItem?.what3words}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                what3words: e.target.value,
              }))
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">///</InputAdornment>
              ),
            }}
            autoComplete="off"
            name="newpopupwhat3words"
          />

          {/* value={selectedItem?.name}
            onChange={(e) =>
              setSelectedItem((prev) => ({ ...prev, name: e.target.value }))
            } */}
          <TextField
            value={selectedItem?.accessInfo ?? ''}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                accessInfo: e.target.value,
              }))
            }
            multiline
            minRows={2}
            title="Access Information / Notes"
            autoComplete="off"
          />
          <Button
            variant="contained"
            color="success"
            size="small"
            type="submit"
          >
            Submit
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            type="button"
            onClick={() => setConfirmDelete(true)}
          >
            Delete
          </Button>
        </Stack>
      </BigModal>
      <SmallModal open={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <Stack gap={1}>
          <Typography variant="title3">
            Are you sure you want to delete {selectedItem?.name}
          </Typography>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Yes - Delete
          </Button>
          <Button
            variant="contained"
            color="info"
            onClick={() => setConfirmDelete(false)}
          >
            No - Cancel
          </Button>
        </Stack>
      </SmallModal>
    </Stack>
  )
}

export default Hospitals
